<template>
  <div id="companies" class="container">
    <div class="popup" v-if="openedPopup">
      <div class="popup-overlay" @click="openedPopup = !openedPopup"></div>
      <div class="popup-content">
        <i class="fa fa-times close" aria-hidden="true" @click="openedPopup = !openedPopup"></i>
        <img :src="'https://cms.zaidounk.com/'+popupCompanyLogo" alt="">
        <div class="company-text" v-html="popupCompanyText"></div>
      </div>
    </div>
    <ul>
      <li v-for="company in companies" :key="company.id">
        <a :href="company.link" target="_blank"><img :src="'https://cms.zaidounk.com/'+company.logo" alt="" class="logo"></a>
        <div class="description"> 
          {{company.body | truncate(120)}}
          <span @click="openPopup(company)">إقرأ المزيد</span>
        </div>
        <ul class="company-social">
          <li v-for="social in company.socialLink" :key="social.id"><a :href="social" target="_blank"><i :class="getSocialType(social)"></i></a></li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
      return {
        companies: '',
        openedPopup: false,
        popupCompanyLogo: '',
        popupCompanyText: ''
      }
  },
  computed: {
  },
  methods: {
    openPopup(company){
      this.popupCompanyLogo = company.logo
      this.popupCompanyText = company.body
      this.openedPopup = true
    },
    getSocialType (social) {
      // return 'facebook'
      if (social.includes('facebook')) {
        return 'fa fa-facebook'
      } else if (social.includes("twitter")) {
        return 'fa fa-twitter'
      } else if (social.includes("instagram")) {
        return 'fa fa-instagram'
      } else if (social.includes("youtube")) {
        return 'fa fa-youtube'
      } else if (social.includes("linkedin")) {
        return 'fa fa-linkedin'
      }
    }
  },
  created () {
    this.$http.get('https://cms.zaidounk.com/api/company')
    .then(result => {
      return result.json()
    })
    .then(data => {
      // console.log(data)

      data.forEach(element => {
        element.socialLink = (element.socialLink || "").split(",")
      });
      this.companies = data;
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/sections/Companies.vue